module.exports = __webpack_public_path__ + "img/荣誉证书04_杨浦区专精特新.e857e479.png";